import { createFileRoute } from "@tanstack/react-router";

// /admin/audit — staff cross-tenant view of the audit trail. PII is
// masked by default in this surface; reveal is itself an auditable
// action (see AuditLogList).
export const Route = createFileRoute("/admin/audit/")({});
